// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1f713d6f","422":"685f5ec9","667":"b660e56a"}[chunkId] + ".chunk.js";
};